export default __webpack_public_path__ + "static/media/krisi_m.2e49f0e3.jpg";